<template>
  <div class="app-shell" :class="{ 'sidebar-collapsed': sidebarCollapsed }">
    <div v-if="mobileOpen" class="mobile-backdrop" @click="mobileOpen = false"></div>

    <aside class="sidebar" :class="{ 'mobile-open': mobileOpen }" aria-label="Menú principal">
      <div class="sidebar-brand">
        <router-link to="/Home" class="brand-link" @click.native="closeMobile">
          <img src="../../assets/qhatunavbar2.png" alt="Qhatu" class="brand-full" />
          <img src="../../assets/logoNavbar2responsive.png" alt="Qhatu" class="brand-compact" />
        </router-link>
        <button class="mobile-close" type="button" aria-label="Cerrar menú" @click="mobileOpen = false">
          <i class="bi bi-x-lg"></i>
        </button>
      </div>

      <div class="sidebar-label">Navegación</div>
      <nav class="sidebar-nav">
        <router-link to="/Home" class="nav-entry home-entry" exact @click.native="closeMobile">
          <span class="nav-icon"><i class="bi bi-grid-1x2"></i></span>
          <span class="nav-text">Inicio</span>
        </router-link>

        <div v-for="(item, moduleIndex) in Items" :key="`${item}-${moduleIndex}`" class="module-block">
          <button
            type="button"
            class="nav-entry module-button"
            :class="{ open: moduloAbierto === moduleIndex }"
            :title="sidebarCollapsed ? item : ''"
            @click="toggleModule(moduleIndex)"
          >
            <span class="nav-icon"><i :class="IconoModulo[moduleIndex] || 'bi bi-folder2-open'"></i></span>
            <span class="nav-text">{{ formatText(item) }}</span>
            <i class="bi chevron" :class="moduloAbierto === moduleIndex ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
          </button>

          <transition name="submenu">
            <div v-if="moduloAbierto === moduleIndex && !sidebarCollapsed" class="submenu">
              <router-link
                v-for="categoria in categoriasPorModulo(item)"
                :key="categoria.idCategoria"
                :to="routeForCategory(categoria)"
                class="submenu-entry"
                @click.native="selectCategory(categoria)"
              >
                <i :class="categoria.desIcono || 'bi bi-circle'"></i>
                <span>{{ formatText(categoria.catNombre) }}</span>
              </router-link>
            </div>
          </transition>
        </div>
      </nav>

      <div class="sidebar-footer">
        <button
          class="sidebar-refresh-button"
          type="button"
          aria-label="Actualizar"
          title="Actualizar"
          @click="actualizarVista"
        >
          <i class="bi bi-arrow-clockwise"></i>
          <span class="nav-text">Actualizar</span>
        </button>
        <button
          class="sidebar-collapse-button"
          type="button"
          :aria-label="sidebarCollapsed ? 'Expandir menú' : 'Contraer menú'"
          :title="sidebarCollapsed ? 'Expandir menú' : 'Contraer menú'"
          @click="toggleSidebar"
        >
          <i :class="sidebarCollapsed ? 'bi bi-layout-sidebar-inset' : 'bi bi-layout-sidebar-inset-reverse'"></i>
          <span class="nav-text">{{ sidebarCollapsed ? 'Expandir menú' : 'Contraer menú' }}</span>
        </button>
        <button class="logout-button" type="button" @click="cerrarSesion">
          <i class="bi bi-box-arrow-left"></i>
          <span class="nav-text">Cerrar sesión</span>
        </button>
      </div>
    </aside>

    <section class="main-area">
      <main class="content-area" :class="{ 'dashboard-content-area': isDashboardRoute }">
        <button class="floating-mobile-menu" type="button" aria-label="Abrir menú" @click="mobileOpen = true">
          <i class="bi bi-list"></i>
        </button>
        <router-view :key="routerViewKey" />
      </main>
    </section>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "BYNavbarVertical",
  data() {
    return { sidebarCollapsed: false, mobileOpen: false, moduloAbierto: null, routerViewKey: 0 };
  },
  computed: {
    ...mapGetters("users", ["Items", "ModuloRapido", "IconoModulo", "Idreporte", "Idgrupo", "NombresUsers", "Cargos", "Correo"]),
    displayName() {
      return (this.NombresUsers || "Usuario Qhatu").trim();
    },
    userInitials() {
      const words = this.displayName.split(/\s+/).filter(Boolean);
      return words.slice(0, 2).map(word => word.charAt(0)).join("").toUpperCase() || "Q";
    },
    currentPageTitle() {
      const name = this.$route.name;
      if (!name || name === "inicio") return "Inicio";
      return this.formatText(name);
    },
    isDashboardRoute() {
      return this.$route && String(this.$route.path || "").startsWith("/Home/cliente/");
    },
  },
  watch: {
    $route() { this.mobileOpen = false; },
  },
  created() {
    this.getAttributes();
    this.ListarPerfil();
    this.ListarCatxPerfil();
    this.ListarCategorias();
    this.ListarModulo();
    this.ListarPerfilxUsuario();
    this.ListarUsuarios();
    this.sidebarCollapsed = localStorage.getItem("qhatu_sidebar_collapsed") === "true";
  },
  methods: {
    ...mapActions("users", ["getAttributes"]),
    ...mapActions("acciones", ["ListarPerfil", "ListarCatxPerfil", "ListarCategorias", "ListarModulo", "ListarPerfilxUsuario", "ListarUsuarios"]),
    formatText(value) {
      if (!value) return "";
      return String(value).toLowerCase().replace(/(^|\s)\S/g, letter => letter.toUpperCase());
    },
    categoriasPorModulo(moduleName) {
      return this.ModuloRapido.filter(category => category.modNombre === moduleName && category.catplataform == 2);
    },
    routeForCategory(category) {
      if (category.idCategoria === 2) return "/Home/configuracion";
      if (category.idCategoria == 3) return "/Home/accesos";
      if (category.idCategoria == 1) return "/Home/usuarios";
      if (category.idCategoria == 85) return "/Home/reportes";
      return `/Home/cliente/${category.idCategoria}`;
    },
    toggleModule(index) {
      if (this.sidebarCollapsed) {
        this.sidebarCollapsed = false;
        localStorage.setItem("qhatu_sidebar_collapsed", "false");
      }
      this.moduloAbierto = this.moduloAbierto === index ? null : index;
    },
    toggleSidebar() {
      this.sidebarCollapsed = !this.sidebarCollapsed;
      this.moduloAbierto = null;
      localStorage.setItem("qhatu_sidebar_collapsed", String(this.sidebarCollapsed));
      this.$store.dispatch("acciones/CambiosEstado", !this.sidebarCollapsed);
    },
    selectCategory(category) {
      this.$store.commit("users/llenarIdreporte", category.idReporte);
      this.$store.commit("users/llenarIdgrupo", category.idGrupo);
      sessionStorage.setItem("qhatu_powerbi_report", category.idReporte || "");
      sessionStorage.setItem("qhatu_powerbi_workspace", category.idGrupo || "");
      this.$store.commit("users/activarTokenbi", true);
      const payload = { idUsuario: localStorage.getItem("userId"), idModulo: category.idModulo, idCategoria: category.idCategoria };
      this.axios.post("BIClientes/RegistrarMonitoreo", payload).catch(() => {});
      this.closeMobile();
    },
    closeMobile() { this.mobileOpen = false; },
    actualizarVista() {
      const isDashboardCliente = this.$route && String(this.$route.path || "").startsWith("/Home/cliente/");
      if (isDashboardCliente) {
        window.dispatchEvent(new CustomEvent("qhatu-refresh-view"));
      } else {
        this.routerViewKey += 1;
      }
      this.closeMobile();
    },
    cerrarSesion() {
      localStorage.clear();
      this.$router.replace("/").catch(() => {});
    },
  },
};
</script>

<style scoped>
.app-shell { min-height: 100vh; display: flex; background: var(--qhatu-bg); }
.sidebar { position: fixed; inset: 0 auto 0 0; z-index: 1040; width: 272px; display: flex; flex-direction: column; color: #fff; background: linear-gradient(180deg, #0757a5 0%, #073e76 100%); box-shadow: 8px 0 30px rgba(6,42,79,.12); transition: width .25s ease, transform .25s ease; }
.sidebar-brand { min-height: 76px; padding: 1rem 1.2rem; display: flex; align-items: center; border-bottom: 1px solid rgba(255,255,255,.12); }
.brand-link { display: flex; align-items: center; min-width: 0; }
.brand-full { width: 142px; max-height: 42px; object-fit: contain; object-position: left; }
.brand-compact { display: none; width: 36px; max-height: 32px; object-fit: contain; }
.mobile-close { display: none; margin-left: auto; border: 0; width: 44px; height: 44px; border-radius: 12px; background: rgba(255,255,255,.1); color: #fff; }
.sidebar-label { padding: 1rem 1.25rem .45rem; color: rgba(255,255,255,.62); font-size: .7rem; font-weight: 750; letter-spacing: .12em; text-transform: uppercase; }
.sidebar-nav { flex: 1; min-height: 0; overflow-y: auto; padding: .35rem .75rem 1rem; scrollbar-width: thin; }
.nav-entry { width: 100%; min-height: 48px; display: flex; align-items: center; gap: .75rem; padding: .65rem .75rem; margin-bottom: .3rem; border: 0; border-radius: 12px; background: transparent; color: rgba(255,255,255,.86); text-decoration: none; text-align: left; transition: background .18s, color .18s; }
.nav-entry:hover, .nav-entry.router-link-exact-active, .module-button.open { color: #fff; background: rgba(255,255,255,.14); }
.nav-icon { width: 26px; min-width: 26px; display: grid; place-items: center; font-size: 1.1rem; }
.nav-text { flex: 1; font-size: .9rem; font-weight: 600; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.chevron { font-size: .75rem; }
.submenu { margin: .1rem 0 .55rem 2.25rem; padding-left: .7rem; border-left: 1px solid rgba(255,255,255,.18); }
.submenu-entry { min-height: 34px; display: flex; align-items: center; gap: .6rem; padding: .35rem .6rem; border-radius: 9px; color: rgba(255,255,255,.76); text-decoration: none; font-size: .68rem; font-weight: 550; text-transform: uppercase; letter-spacing: .025em; line-height: 1.25; }
.submenu-entry i { font-size: .78rem; min-width: 15px; display: grid; place-items: center; }
.submenu-entry:hover, .submenu-entry.router-link-active { background: rgba(255,255,255,.12); color: #fff; }
.sidebar-footer { padding: .9rem .75rem 1rem; border-top: 1px solid rgba(255,255,255,.12); }
.user-mini { display: flex; align-items: center; gap: .7rem; padding: .5rem; margin-bottom: .5rem; }
.user-avatar { width: 40px; height: 40px; min-width: 40px; display: grid; place-items: center; border-radius: 12px; background: #eaf3fc; color: var(--qhatu-primary); font-weight: 800; font-size: .82rem; }
.user-mini .user-avatar { background: rgba(255,255,255,.16); color: #fff; }
.user-mini-copy { min-width: 0; display: flex; flex-direction: column; }
.user-mini-copy strong { font-size: .79rem; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.user-mini-copy span { font-size: .7rem; color: rgba(255,255,255,.65); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.sidebar-refresh-button, .sidebar-collapse-button, .logout-button { width: 100%; min-height: 44px; border: 0; border-radius: 11px; display: flex; align-items: center; gap: .8rem; padding: 0 .8rem; background: rgba(255,255,255,.08); color: #fff; }
.sidebar-refresh-button { margin-bottom: .5rem; background: rgba(255,255,255,.14); }
.sidebar-collapse-button { margin-bottom: .5rem; background: rgba(255,255,255,.12); }
.sidebar-refresh-button:hover, .sidebar-collapse-button:hover, .logout-button:hover { background: rgba(255,255,255,.18); }
.main-area { width: calc(100% - 272px); min-height: 100vh; margin-left: 272px; transition: width .25s, margin-left .25s; }
.content-area { position: relative; padding: clamp(1rem, 2.5vw, 2rem); min-width: 0; }
.content-area.dashboard-content-area { padding: 0 !important; overflow: hidden; }
.floating-mobile-menu { display: none; position: fixed; top: .85rem; left: .85rem; z-index: 1025; width: 44px; height: 44px; border: 1px solid var(--qhatu-border); border-radius: 12px; background: rgba(255,255,255,.98); color: #526077; box-shadow: 0 10px 28px rgba(15, 23, 42, .12); }
.floating-mobile-menu:hover { border-color: #b9c8dc; color: var(--qhatu-primary); }
.sidebar-collapsed .sidebar { width: 76px; }
.sidebar-collapsed .main-area { width: calc(100% - 76px); margin-left: 76px; }
.sidebar-collapsed .brand-full, .sidebar-collapsed .sidebar-label, .sidebar-collapsed .nav-text, .sidebar-collapsed .chevron, .sidebar-collapsed .user-mini-copy { display: none; }
.sidebar-collapsed .brand-compact { display: block; }
.sidebar-collapsed .sidebar-brand { justify-content: center; padding-inline: .75rem; }
.sidebar-collapsed .nav-entry { justify-content: center; padding-inline: .55rem; }
.sidebar-collapsed .user-mini { justify-content: center; padding-inline: 0; }
.sidebar-collapsed .sidebar-refresh-button, .sidebar-collapsed .sidebar-collapse-button, .sidebar-collapsed .logout-button { justify-content: center; padding-inline: 0; }
.submenu-enter-active, .submenu-leave-active { transition: all .2s ease; }
.submenu-enter, .submenu-leave-to { opacity: 0; transform: translateY(-5px); }
.mobile-backdrop { display: none; }
@media (max-width: 991.98px) {
  .sidebar, .sidebar-collapsed .sidebar { width: min(86vw, 310px); transform: translateX(-105%); }
  .sidebar.mobile-open { transform: translateX(0); }
  .main-area, .sidebar-collapsed .main-area { width: 100%; margin-left: 0; }
  .content-area { padding-top: 4.25rem; }
  .content-area.dashboard-content-area { padding: 0 !important; }
  .floating-mobile-menu, .mobile-close { display: grid; place-items: center; }
  .mobile-backdrop { display: block; position: fixed; inset: 0; z-index: 1035; background: rgba(12,24,42,.48); backdrop-filter: blur(2px); }
  .sidebar-collapsed .brand-full, .sidebar-collapsed .sidebar-label, .sidebar-collapsed .nav-text, .sidebar-collapsed .chevron, .sidebar-collapsed .user-mini-copy { display: initial; }
  .sidebar-collapsed .brand-compact { display: none; }
  .sidebar-collapsed .sidebar-brand { justify-content: initial; padding-inline: 1.2rem; }
  .sidebar-collapsed .nav-entry { justify-content: initial; padding-inline: .75rem; }
  .sidebar-collapsed .user-mini { justify-content: initial; padding-inline: .5rem; }
  .sidebar-collapsed .sidebar-refresh-button, .sidebar-collapsed .sidebar-collapse-button, .sidebar-collapsed .logout-button { justify-content: initial; padding-inline: .8rem; }
  .sidebar-collapse-button { display: none; }
}
@media (max-width: 575.98px) {
  .content-area { padding: .85rem; padding-top: 3.75rem; }
  .content-area.dashboard-content-area { padding: 0 !important; }
  .floating-mobile-menu { top: .65rem; left: .65rem; }
}
</style>
